import {
  comlogin,
  // logout,
  sendcode,
  // getcominfo
} from '@/api/user'
import {getcominfo} from '@/api/indexPage'
// import { setToken, getToken } from '@/libs/util'

export default {
  state: {
    // token: getToken(),
    siteInfo: {}
  },
  mutations: {
    // setToken (state, token) {
    //   state.token = token
    //   setToken(token)
    // },
    setDefaultContact (state, siteInfo) {
      state.siteInfo = siteInfo
    }
  },
  getters: {
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { phone, smsCode = '', login_type, password = '', type, captcha_appid = '', captcha_randstr = '', captcha_ticket = '' }) {
      phone = phone.trim()
      return new Promise((resolve, reject) => {
        comlogin({
          phone,
          smsCode,
          type,
          login_type,
          password,
          captcha_appid,
          captcha_randstr,
          captcha_ticket
        }).then(res => {
          const data = res
          if (res.apiStatus) {
            // commit('setToken', data.data.user_id)
            console.log('====')
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    // 发短信
    sendCode ({ commit }, { phone, type = 2, service_code, captcha_appid, captcha_randstr, captcha_ticket }) {
      // console.log('sendCode action', phone)
      return new Promise((resolve, reject) => {
        sendcode({
          phone,
          type,
          service_code,
          captcha_appid,
          captcha_randstr,
          captcha_ticket
        }).then(res => {
          console.log('发短信-rews',res)
          const data = res
          if (res.apiStatus) {
            resolve(data)
          } else {
            reject(data)
          }
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        sessionStorage.removeItem('protocolStatus')
        // commit('setToken', '')
        resolve()
      })
    },
    // 获取站点信息
    async getDefaultContact ({ commit }) {
      let locationOrigin = window.location.origin
      let domain = locationOrigin.split('//')[1]
      let { data } = await getcominfo({ domain })
      console.log('data', data)
      localStorage.setItem('coedImg', JSON.stringify(data.data.company_concat_qr_code_url))
      commit('setDefaultContact', data.data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js